import { ApplicationRoutes } from '../../constants/appRoutes';

export const footerItems = [
  {
    text: 'Home',
    to: ApplicationRoutes.client.home
  },
  {
    text: 'About Us',
    to: ApplicationRoutes.client.aboutUs
  },
  {
    text: 'Contact Us',
    to: ApplicationRoutes.client.contactUs
  },
  {
    text: 'Listing Markets',
    to: ApplicationRoutes.client.listingMarkets
  },
  {
    text: 'Market Reports',
    to: ApplicationRoutes.client.marketReports
  },
  {
    text: 'Support / Demo',
    to: ApplicationRoutes.client.supportAndDemo
  },
  {
    text: 'Buyer Approval',
    to: ApplicationRoutes.client.buyerApproval
  },
  {
    text: 'Privacy Policy',
    to: '/market-reports'
  },
  {
    text: 'Terms of Service',
    to: '/support-and-demo'
  }
];
